module.exports = __webpack_public_path__ + "img/3-min.c3563f60.jpg";